import { useEffect, useState } from 'react';

interface Props {
    className: string;
    url?: string;
    offset?: string | number;
    duration?: string | number;
}
const useVideo = ({ className, url, offset = '50%', duration = '100%' }: Props) => {
    const [top, setTop] = useState(0);
    const [enter, setEnter] = useState(false);
    const [src, setSrc] = useState('');
    useEffect(() => {
        if (typeof window !== 'undefined') {
            let initTop = 0;
            const arr: string[] = ['ef-nav-product', 'ef-product-naver', 'ecoflow-frame-header', 'regionPopup'];
            arr.forEach((item) => {
                const el = document.querySelector(`.${item}`) as HTMLElement;
                if (el) {
                    const styles = window.getComputedStyle(el);
                    const position = styles.position;
                    initTop += Number(position === 'sticky' ? el?.offsetHeight : 0) || 0;
                }
            });
            setTop(initTop);

            AniContainer.create({
                triggerElement: `.${className}`,
                triggerHook: 1,
                offset: '-400%',
                onEnter: () => {
                    setSrc(url ?? '');
                },
            });

            AniContainer.create({
                triggerElement: `.${className}`,
                triggerHook: 1,
                offset,
                duration,
                onEnter: () => {
                    setEnter(true);
                    const video: HTMLVideoElement | null = document.querySelector(`.${className} video`);
                    if (video) {
                        video.play();
                    }
                },
                onLeave: () => {
                    setEnter(false);
                    const video: HTMLVideoElement | null = document.querySelector(`.${className} video`);
                    if (video) {
                        video.pause();
                    }
                },
            });
        }
    }, []);

    return {
        top,
        enter,
        src,
    };
};

export default useVideo;
